import React, { useEffect, useRef, useState } from "react";
import './GroupDropdownMenu.css';
import GetAccessToken from "./Tokens";
import dropDownOpenIcon from "./icons/dropdown-open.png";
import dropDownCloseIcon from "./icons/dropdown-close.png";
import editIcon from "./icons/edit-2.png";
import deleteIcon from "./icons/delete.png";
import {useNavigate} from "react-router-dom";
import { useConfig } from './ConfigContext';

function GroupDropdownMenu({setIsGroupFormOpen, newGroup, selectedGroup, setSelectedGroup, onEditGroup, groups, setGroups}) {
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [groupServiceUrl, setGroupServiceUrl] = useState(null);
    const config = useConfig();

    useEffect(() => {
        if (config) {
            setGroupServiceUrl(config["group_service_url"]);
        }
    }, [config]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [setOpen]);

    useEffect(() => {

        if(loading !== true || groupServiceUrl == null)
            return;

        const fetchData = async () => {
            fetch(groupServiceUrl + '/public/list?include_description=true', {
            }).then(async response => {
                if (response.status === 401) {
                    sessionStorage.removeItem('access_token');
                    console.error('Unauthorized:', response.statusText);
                    await fetchData();
                }
                return response.json();
            })
                .then(data => {
                    setGroups(data["groups"]);
                    setLoading(false);
                })
                .catch(error => {
                    if (error.message !== 'Unauthorized') {
                        console.error('Error fetching the models:', error);
                    }
                });
        };

        fetchData();
    }, [loading, groupServiceUrl]);


    useEffect(() => {
        groups.push(newGroup);
        setSelectedGroup(newGroup);
    }, [newGroup]);

    const handleChange = (event) => {
        setSelectedGroup(event.target.value);
    };

    const handleSelect = (group) => {
        setSelectedGroup(group);
        setOpen(false);
    };

    const handleEdit = (group) => {
        setOpen(false);
        onEditGroup(group);
    };

    const handleDelete = async (group) => {
        GetAccessToken(config["user_service_url"]).then(access_token => {
            const formData = new FormData();
            formData.append('group_id', group["group_id"]);
            if (access_token === null) {
                navigate('/login');
            }
            fetch(groupServiceUrl + '/private/group', {
                method: 'DELETE',
                body: formData,
                headers: {
                    'Authorization': `Bearer ${access_token}`
                }
            })
                .then(async response => {
                    if (response.status === 401) {
                        sessionStorage.removeItem('access_token');
                        console.error('Unauthorized:', response.statusText);
                        await handleDelete(group);
                    }
                })
                .then(data => {
                    setSelectedGroup(null);
                    setLoading(true);
                })
                .catch(error => {
                    if (error.message !== 'Unauthorized') {
                        console.error('Error fetching the models:', error);
                    }
                });
        })
    };

    const handleNewGroup = () => {
        setOpen(false);
        setIsGroupFormOpen(true);
    };

    if (loading) {
        return <p>Loading groups...</p>;
    }

    return (
        <div className="dropdown-container" ref={dropdownRef}>
            <button className="DropDownSelectedButton"
                    onClick={() => setOpen(!open)}>
                {(selectedGroup && selectedGroup["group_name"]) || 'Choose a group...'}
                {!open && <img src={dropDownOpenIcon} alt="icon" className="dropdown-icon" />}
                {open && <img src={dropDownCloseIcon} alt="icon" className="dropdown-icon" />}
            </button>
            {open && (
                <ul className="dropdown-menu">
                    {groups.map((group, index) => (
                        <li
                            onClick={() => handleSelect(group)}
                            key={index}
                            className="dropdown-item"
                        >
                            <span>{group["group_name"]}</span>
                            <div className="icon-container">
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleEdit(group);
                                    }}
                                    className="edit-button"
                                >
                                    <img src={editIcon} alt="edit-icon" className="edit-icon" />
                                </button>
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleDelete(group);
                                    }}
                                    className="delete-button"
                                >
                                    <img src={deleteIcon} alt="delete-icon" className="delete-icon" />
                                </button>
                            </div>
                        </li>
                    ))}
                    <li
                        onClick={() => handleNewGroup()}
                        className="new-item"
                    >
                        <span>create a new group...</span>
                    </li>
                </ul>
            )}
        </div>
    );
}

export default GroupDropdownMenu;
